module.exports = __webpack_public_path__ + "img/image103.33763129.jpg";